import React from 'react';
import DashboardLayout from '../DashboardLayout';

const SettingsLayout: React.FC = () => {
    return (
        <DashboardLayout />
    );
};

export default SettingsLayout;
